var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 6,
    fill: "#FDE7B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3021 19.2457H21.8646M14.3021 24.0623H18.0833M8 8.4083V27.6747C8 28.3134 8.26559 28.926 8.73833 29.3776C9.21108 29.8293 9.85226 30.083 10.5208 30.083H25.6458C26.3144 30.083 26.9555 29.8293 27.4283 29.3776C27.901 28.926 28.1666 28.3134 28.1666 27.6747V13.6367C28.1666 13.3159 28.0994 12.9983 27.9691 12.7026C27.8388 12.4069 27.648 12.1391 27.4079 11.9148L21.8116 6.68637C21.3407 6.24644 20.7082 6.00008 20.0496 6H10.5208C9.85226 6 9.21108 6.25373 8.73833 6.70537C8.26559 7.15702 8 7.76958 8 8.4083Z",
    stroke: "#9C6D09",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6045 6V10.8166C20.6045 11.4553 20.8701 12.0679 21.3428 12.5195C21.8156 12.9712 22.4568 13.2249 23.1253 13.2249H28.167",
    stroke: "#9C6D09",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2);
export default __webpack_public_path__ + "static/media/key2.291d9827d6d40790be73c8480d1467c5.svg";
export { ForwardRef as ReactComponent };